

export const B2BOPTIONS = {
    offerText: {
      optionName: "Offer Text",
      optionValue: "offerText",
      customizeProperties: {
        text: {
          propertyName: "Text",
          propertyType: "text",
          propertyMaxLength: "150",
          propertyValue:
            "Get an exclusive 10% off if you order in next 60 minutes!",
        },
        textColor: {
          propertyName: "Text-Color",
          propertyType: "color",
          propertyValue: "#000000",
        },
        fontStyle: {
            propertyName: "Font-Style",
            propertyType: "select",
            propertyValue: "normal",
            propertyOptions: [
              {
                optionName: "Normal",
                optionValue: "normal",
              },
              {
                optionName: "Italic",
                optionValue: "italic",
              },
            ],
        },
        fontFamily: {
          propertyName: 'Font-Family',
          propertyType: 'select',
          propertyValue: 'sans-serif',
          propertyOptions: [
            {
              optionName: "Serif",
              optionValue: "serif",
            },
            {
              optionName: "Cursive",
              optionValue: "cursive",
            },
            {
              optionName: "Sans-Serif",
              optionValue: "sans-serif",
            },
          ],
        },
      },
    },
    offerTitle: {
      optionName: "Offer Title",
      optionValue: "offerTitle",
      customizeProperties: {
        text: {
          propertyName: "Text",
          propertyType: "text",
          propertyMaxLength: "30",
          propertyValue: "** ONE TIME EXCLUSIVE OFFER **",
        },
        textColor: {
          propertyName: "Text-Color",
          propertyType: "color",
          propertyValue: "#000000",
        },
        fontStyle: {
          propertyName: "Font-Style",
          propertyType: "select",
          propertyValue: "normal",
          propertyOptions: [
            {
              optionName: "Normal",
              optionValue: "normal",
            },
            {
              optionName: "Italic",
              optionValue: "italic",
            },
          ],
        },
        fontFamily: {
            propertyName: 'Font-Family',
            propertyType: 'select',
            propertyValue: 'sans-Serif',
            propertyOptions: [
              {
                optionName: "Sans-Serif",
                optionValue: "sans-serif",
              },
              {
                optionName: "Serif",
                optionValue: "serif",
              },
              {
                optionName: "Cursive",
                optionValue: "cursive",
              },
            ],
        },
      },
    },
    heroImage: {
      optionName: "Hero Image",
      optionValue: "heroImage",
      customizeProperties: {
        image: {
            propertyName: 'Image',
            propertyType: 'file',
            propertyValue: '',
        },
        imageHeight: {
          propertyName: 'Image Height',
          propertyType: 'select',
          propertyValue: '100',
          propertyOptions: [
            {
              optionName: "90",
              optionValue: "90",
            },
            {
              optionName: "100",
              optionValue: "100",
            },
            {
              optionName: "110",
              optionValue: "110",
            },
            {
              optionName: "120",
              optionValue: "120",
            },
            {
              optionName: "130",
              optionValue: "130",
            },
            {
              optionName: "140",
              optionValue: "140",
            },
            {
              optionName: "150",
              optionValue: "150",
            },
            {
              optionName: '160',
              optionValue: '160'
            }
          ],
        },
        borderRadius: {
          propertyName: 'Border Radius',
          propertyType: 'text',
          propertyValue: '12'
        }
      },
    },
    inputFields: {
        optionName: "Input Fields",
        optionValue: "inputFields",
        lastActiveField: 'Input Field 3',
        customizeProperties: {
            field1: {
                propertyName: "Input Field 1",
                propertyType: ['text', 'checkbox'],
                propertyValues: [
                    'Enter your email',
                    'Required'
                ],
                active: true
            },
            field2:
            {
                propertyName: "Input Field 2",
                propertyType: ['text', 'checkbox'],
                propertyValues: [
                    'Enter your phone',
                    'Required'
                ],
                active: true
            },
            field3:
            {
                propertyName: "Input Field 3",
                propertyType: ['text', 'checkbox'],
                propertyValues: [
                    'Enter your name',
                    ''
                ],
                active: true
            },
            field4:
            {
                propertyName: "Input Field 4",
                propertyType: ['text', 'checkbox'],
                propertyValues: [
                    '',
                    ''
                ],
                active: false
            },
            field5:
            {
                propertyName: "Input Field 5",
                propertyType: ['text', 'checkbox'],
                propertyValues: [
                    '',
                    ''
                ],
                active: false
            },
            field6:
            {
                propertyName: "Input Field 6",
                propertyType: ['text', 'checkbox'],
                propertyValues: [
                    '',
                    ''
                ],
                active: false
            },
            backgroundColor: {
                propertyName: "Background-Color",
                propertyType: "color",
                propertyValue: "#ffffff",
            },
            borderColor: {
                propertyName: "Border-Color",
                propertyType: "color",
                propertyValue: "#000000",
            },
            borderStyle: {
                propertyName: "Border-Style",
                propertyType: "select",
                propertyValue: "solid",
                propertyOptions: [
                    {
                        optionName: "None",
                        optionValue: "none",
                    },
                    {
                        optionName: "Dotted",
                        optionValue: "dotted",
                    },
                    {
                        optionName: "Dashed",
                        optionValue: "dashed",
                    },
                    {
                        optionName: "Solid",
                        optionValue: "solid",
                    },
                ],
            },
            borderWidth: {
                propertyName: "Border-Width",
                propertyType: "number",
                propertyValue: 1,
            },
        }
    },
    
    copyText: {
        optionName: 'Copy Text',
        optionValue: 'copyText',
        customizeProperties: {
            text: {
                propertyName: "Text",
                propertyType: "text",
                propertyMaxLength: "30",
                propertyValue: "GET MY DISCOUNT",
            },
            textColor: {
                propertyName: "Text-Color",
                propertyType: "color",
                propertyValue: "#ffffff",
            },
            backgroundColor: {
                propertyName: "Before-Code Background-Color",
                propertyType: "color",
                propertyValue: "#005575",
            },
            codeBackgroundColor: {
              propertyName: "After-Code Background-Color",
              propertyType: "color",
              propertyValue: "#008060",
            },
            borderColor: {
                propertyName: "Border-Color",
                propertyType: "color",
                propertyValue: "#ffffff",
            },
            borderStyle: {
                propertyName: "Border-Style",
                propertyType: "select",
                propertyValue: "solid",
                propertyOptions: [
                    {
                        optionName: "None",
                        optionValue: "none",
                    },
                    {
                        optionName: "Dotted",
                        optionValue: "dotted",
                    },
                    {
                        optionName: "Dashed",
                        optionValue: "dashed",
                    },
                    {
                        optionName: "Solid",
                        optionValue: "solid",
                    },
                ],
            },
            borderWidth: {
                propertyName: "Border-Width",
                propertyType: "number",
                propertyValue: 0,
            },

        },
    },
    nudge: {
        optionName: "Nudge",
        optionValue: "nudge",
        customizeProperties: {
          backgroundColor: {
            propertyName: "Background-Color",
            propertyType: "color",
            propertyValue: "#ffffff",
          },
          borderColor: {
            propertyName: "Border-Color",
            propertyType: "color",
            propertyValue: "#ffffff",
          },
          borderStyle: {
            propertyName: "Border-Style",
            propertyType: "select",
            propertyValue: "solid",
            propertyOptions: [
              {
                optionName: "None",
                optionValue: "none",
              },
              {
                optionName: "Dotted",
                optionValue: "dotted",
              },
              {
                optionName: "Dashed",
                optionValue: "dashed",
              },
              {
                optionName: "Solid",
                optionValue: "solid",
              },
            ],
          },
          borderWidth: {
            propertyName: "Border-Width",
            propertyType: "number",
            propertyValue: 0,
          },
        },
        nudgePosition: {
          optionName: "Nudge Position",
          optionValue: "nudgePosition",
          customizeProperties: {
            desktop: {
              top: 0,
              left: 0,
            },
            mobile: {
              top: 0,
            },
          },
        },
      },
  };